
import { Delete } from "@mui/icons-material";
import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Pagination,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";
 
const BillingTable = forwardRef((props, ref) => {
  const theme = useTheme();
  const classes = useStyle();
  const outletId = localStorage.getItem("outlet_id")
  const {data, setData,code, setCode, setPostData , postData , docName,options, setOptions,subData,setSubData,catData,setCatData, allSubData, setAllSubData,orderDetails1,setOrderDetails} = props
  const [itemData, setItemData] = useState(null)
  const [qty, setQty] = useState('')
  const dispatch = useDispatch()
  const [rateData, setRateData] = useState({
    mrp : '',
    disc :'',
    rate :'',
    gst : '',
    prod_id : ''
  })

  const [endCode, setEndCode] = useState('')
  const [codeNo, setCodeNo] = useState('')
  const [filteredData, setFilteredData] = useState(data);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [barcode, setBarcode] = useState(''); // Add this line to define barcode state
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [pageCount, setPageCount] = useState(0);
      // const [orderDetails1, setOrderDetails] = useState(data);
const [page, setPage] = useState(1);
const itemsPerPage = 10;
  console.log(orderDetails1.length,"catDatapageCount3333");
  const paginatedData = data[0]?.data?.slice((page - 1) * itemsPerPage, page * itemsPerPage) || [];

  const codeRef = useRef(null)
  const qtyRef = useRef(null)
  const updatedRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
    qty : useRef(null)
  }

function handleCheckQty(startCode, newEndCode, rateObj) {
  // Simulating available stock
  const availableStock = 100;

  // Ensure qty is assigned properly
  const order_qty = qty === "" || qty === 0 ? 0 : Math.min(qty, availableStock);
console.log(order_qty,"order_qty");

  // Total quantity to consider for calculations
  const totalQty = order_qty;

  // GST and CESS Calculations
  const discountedMrp = rateObj.mrp * (1 - (rateObj.disc || 0) / 100);
  const gstAmt = Number(((rateObj.mrp || 0) * (rateObj.gst || 0) / 100).toFixed(2)) * totalQty;
  const cessAmt = parseFloat(((discountedMrp) * ((rateObj.cess || 0) / 100) * totalQty).toFixed(2));
  const totalAmt = parseFloat(((rateObj.rate - rateObj.rate * (rateObj.disc || 0) / 100) * totalQty).toFixed(2));
console.log(gstAmt,"gstAmt12");

  if (order_qty <= availableStock) {
    const objData = {
      code: startCode,
      order_qty: order_qty,
      prod_id: rateObj.prod_id,
      mrp1: rateObj.mrp,
      rate1: rateObj.rate,
      gst1: rateObj.gst,
      disc1: rateObj.disc,
      gstAmt: gstAmt,
      cessAmt: cessAmt,
      totalAmt: totalAmt,
      ...rateObj,
    };

    console.log(objData, "Updated Values");

    const existingItemIndex = data.findIndex(
      (item) => item.code === objData.code && (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1)
    );
    
    const arr = [...data];

    if (existingItemIndex !== -1) {
      arr[existingItemIndex].qty = parseFloat(arr[existingItemIndex].qty) + parseFloat(objData.order_qty);
      arr[existingItemIndex].gstAmt = (parseFloat(arr[existingItemIndex].rate1) * (parseFloat(arr[existingItemIndex].gst1) / 100)) * parseFloat(arr[existingItemIndex].qty);
      arr[existingItemIndex].cessAmt = ((parseFloat(arr[existingItemIndex].rate1) - parseFloat(arr[existingItemIndex].rate1) * (parseFloat(arr[existingItemIndex].disc1) / 100)) * (parseFloat(arr[existingItemIndex].cess) / 100)) * parseFloat(arr[existingItemIndex].qty);
      arr[existingItemIndex].totalAmt = ((parseFloat(arr[existingItemIndex].rate1) - parseFloat(arr[existingItemIndex].rate1) * (parseFloat(arr[existingItemIndex].disc1) / 100)) * parseFloat(arr[existingItemIndex].qty));
    } else {
      arr.push(objData);
    }

    setData(arr);
    setCode("");
    setQty("");
    setEndCode("");
    setItemData(null);
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst: "", disc: "", prod_id: "" }));
    codeRef.current.focus();
  } else {
    dispatch(setSnackbar(true, "error", `Quantity exceeds available stock`));
  }
}

console.log(options,"daata08888options");
// const getMinimunStock = (id, pageSize, page) => {
//   axios
//     .get(`/v1/indent/order/min/stock/subcatogory/${options?.category !==null ? options?.category?.id : 0}/${options?.subCategory !==null ? options?.subCategory?.id : 0}/${options?.customer?.id}`)
//     // .get(`/v1/indent/order/min/stock/${pageSize}/${currentPage}/${outletId}`)
//     .then((res) => {
//       setItemData(res.data?.data);
//       setData(res.data?.data)
//       setEndCode(id);
//       setOrderDetails(res.data?.data)

//       const rateObj = {
//         mrp: res.data.mrp,
//         rate: res.data.pur_rate,
//         gst: res.data.gst,
//         disc: res.data.discount,
//         prod_id: res.data.prod_id,
//         ...res.data,
//       };

//       qtyRef.current.focus();
//       setPageCount(res.data.meta.pagination.total);
//       setTotalPages(res.data.meta.pagination?.total_pages || 1);

//       handleCheckQty(id, id, rateObj);
//     })
//     .catch((err) => {
//       // setData([])
//        const status = err.response?.status;
//   const message = err.response?.data?.errors?.[0]?.message || "Something went wrong";
//         if (status === 404) {
//           setOrderDetails([])
//       dispatch(setSnackbar(true, "error", err.response?.data?.errors[0].message));

//   }
//     });
// };

const getMinimunStock = (id, pageSize, page) => {
  axios
    .get(`/v1/indent/order/min/stock/subcatogory/${options?.category !== null ? options?.category?.id : 0}/${options?.subCategory !== null ? options?.subCategory?.id : 0}/${options?.customer?.id}`)
    .then((res) => {
      const responseData = res.data?.data || [];
      
      // Loop to calculate GST, CESS, Total for each item initially
      const updatedData = responseData.map((item) => {
        const qty = parseFloat(item.order_qty) || 0;
        const pur_rate = parseFloat(item.pur_rate) || 0;
        const disc1 = parseFloat(item.discount) || 0;
        const gst1 = parseFloat(item.gst) || 0;
        const cess = parseFloat(item.cess) || 0;

        const discountAmountPerUnit = pur_rate * (disc1 / 100);
        const priceAfterDiscount = pur_rate - discountAmountPerUnit;
        const totalAmount = priceAfterDiscount * qty;
        const gstAmount = totalAmount * (gst1 / 100);
        const cessAmount = totalAmount * (cess / 100);
        const totalWithGST = totalAmount + gstAmount + cessAmount;

        return {
          ...item,
          discountAmt: (discountAmountPerUnit * qty).toFixed(2),
          gstAmt: gstAmount.toFixed(2),
          cessAmt: cessAmount.toFixed(2),
          totalAmt: totalAmount.toFixed(2),
          totalWithGST: totalWithGST.toFixed(2),
        };
      });

      setItemData(res.data?.data);
      setData([{ ...res.data, data: updatedData }]);
      setEndCode(id);
      setOrderDetails(updatedData);

      const rateObj = {
        mrp: res.data.mrp,
        rate: res.data.pur_rate,
        gst: res.data.gst,
        disc: res.data.discount,
        prod_id: res.data.prod_id,
        ...res.data,
      };

      qtyRef.current.focus();
      setPageCount(res.data.meta.pagination.total);
      setTotalPages(res.data.meta.pagination?.total_pages || 1);

      handleCheckQty(id, id, rateObj);
    })
    .catch((err) => {
      const status = err.response?.status;
      const message = err.response?.data?.errors?.[0]?.message || "Something went wrong";
      if (status === 404) {
        setOrderDetails([]);
        dispatch(setSnackbar(true, "error", message));
      }
    });
};

  console.log(docName,"docName");
  
  const clearNew = () =>{
    setCode('')
    setEndCode("")
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
 console.log(orderDetails1,"orderDetails1response");
 
const handleOrderQtyChange = (index, value) => {
  const orderDetails = orderDetails1 || [];
  const updatedOrderDetails = [...orderDetails];

  const qty = parseFloat(value.replace(/\D/g, '')) || 0;
  const item = updatedOrderDetails[index];

  if (!item) return;

  setCodeNo(item.code);

  const mrp = parseFloat(item.mrp) || 0;
  const pur_rate = parseFloat(item.pur_rate) || 0;
  const disc1 = parseFloat(item.discount) || 0;
  const gst1 = parseFloat(item.gst) || 0;
  const cess = parseFloat(item.cess) || 0;

  // Step 1: Calculate discount
  const discountAmountPerUnit = pur_rate * (disc1 / 100);
  const priceAfterDiscount = pur_rate - discountAmountPerUnit;

  // Step 2: Calculate total amount before tax
  const totalAmount = priceAfterDiscount * qty;

  // Step 3: Calculate GST & CESS on discounted total
  const gstAmount = totalAmount * (gst1 / 100);
  const cessAmount = totalAmount * (cess / 100);

  // Step 4: Final total
  const totalWithGST = totalAmount + gstAmount + cessAmount;
  // const totalWithGST = totalAmount + gstAmount + cessAmount;

  updatedOrderDetails[index] = {
    ...item,
    order_qty: qty,
    discountAmt: (discountAmountPerUnit * qty).toFixed(2),
    gstAmt: gstAmount.toFixed(2),
    cessAmt: cessAmount.toFixed(2),
    totalAmt: totalAmount.toFixed(2),
    totalWithGST: totalWithGST.toFixed(2),
  };

  const updatedData = [{ ...data[0], data: updatedOrderDetails }];
  setOrderDetails(updatedOrderDetails);
  setData(updatedData);
  console.log(updatedOrderDetails,updatedData,"updatedOrderDetails");

};

 useImperativeHandle(ref, () => ({
  focusCodeInput: () => {
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
}));


useEffect(() => {
  const totalItems = data.length; // Get the count of items in the data array
  // const totalItems = data.length; // Get the count of items in the data array
  setPostData((prevState) => ({
    ...prevState,
    total_items: totalItems, // Set total_items in the postData state
  }));
}, [data]); // Re-run when 'data' changes

useEffect(() => {
  const totalPageCount = Math.ceil(data.length / pageSize);
  if (currentPage > totalPageCount) {
    setCurrentPage(totalPageCount || 1);
  }
}, [data.length, pageSize]);

useEffect(() => {
  // Reset page only when code changes
  setCurrentPage(1);
}, [code]);

useEffect(() => {
    getMinimunStock();
}, [options]);

return (
  <Box position="relative" width="100%">
<Typography  textAlign="right"  sx={{  color: "black",fontWeight: "bold" }}>
   Total Item Count : {orderDetails1?.length || 0}
   </Typography>
    <Grid className="w-full h-full">
              <TableContainer className={classes.tblRoot} sx={{ height: 400, overflow: "auto", }}>
  <Table stickyHeader className={classes.table}>
    <TableHead className={classes.tblHeader}  sx={{
      '& .MuiTableCell-root': {
        padding: 1,
        fontSize:12,
      },
    }}>
      <TableRow className={classes.tablrow}>
        <TableCell className={classes.tblCell} sx={{ borderLeft: "0.5px solid #ccc" }}>Sno</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }}>Code</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }}>Product Name</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }}>SubCategory</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }}>Avg Qty</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">Order Qty</TableCell>
        {/* <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">Purchase Rate</TableCell> */}
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">Mrp</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">GST</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">CESS</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">GST Amount</TableCell>
        <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">Total Amount</TableCell>
      </TableRow>
    </TableHead>
    
    <TableBody  sx={{
      '& .MuiTableCell-root': {
        padding: 1,
        fontSize:12,
      },
    }}>

         {orderDetails1.length > 0 ? (
    orderDetails1.map((item, index) => (
        <TableRow key={item.prod_id} className={classes.tablrow}>
          <TableCell className={classes.tblContentCell} sx={{ borderLeft: "0.5px solid #ccc" }}>{index + 1}</TableCell>
          <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }}>{item.pro_code}</TableCell>
          <TableCell className={classes.tblCell} sx={{ width: "20%", textAlign: "center" }}>{item.pro_name}</TableCell>
          <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }}>{item.subcategory_name}</TableCell>
          <TableCell className={classes.tblCell} sx={{ width: "6%", textAlign: "center" }}>{item.avgqtylast3months}</TableCell>
          <TableCell align="right">
            <TextField
              size="small"
              value={item.order_qty || 0}
              className={classes.tableInput}

              onChange={(e) => handleOrderQtyChange(index, e.target.value)}
             InputProps={{
                sx: {
                  '& input': {
                    padding: '4px',
                  },
                },
              }}
           />
          </TableCell>
          {/* <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">{item.pur_rate}</TableCell> */}
          <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">{item.mrp}</TableCell>
          <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">{item.gst}</TableCell>
          <TableCell className={classes.tblCell} sx={{ width: "10%", textAlign: "center" }} align="right">{item.cess}</TableCell>
          <TableCell align="right" >{item.gstAmt}</TableCell>
          <TableCell align="right">{item.totalAmt}</TableCell>

        </TableRow>
          ))
  ) : (
    <TableRow>
      <TableCell colSpan={11} align="center">
        No Data Available
      </TableCell>
    </TableRow>
  )}
    </TableBody>
  </Table>
</TableContainer>


    </Grid>
     {loading && (
      <Box
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        position="absolute" 
        top={0} 
        left={0} 
        right={0} 
        bottom={0} 
        bgcolor="rgba(255, 255, 255, 0.7)" // Optional: background color for the overlay
        zIndex={1}
      >
        <CircularProgress size={50}/> {/* Material UI spinner */}
      </Box>
    )}
    </Box>
  );
});

export default memo(BillingTable);

